const timelineData = [
    {
        "sectionId": "golden-period",
        "range": "2000-2008",
        "title": "Golden Manufacturing period",
        "backgroundColor": "rgb(185, 213, 97)",
        "textColor": "#FFFFFF",
        "events": [
            {
                "order": 1,
                "items": {
                    "left": {
                        "position": "left",
                        "type": "card",
                        "title": "2000",
                        "description": "<ul><li>Rainbow founded in Jinan, Shandong\nProvince, China.</li><li>Leased the first production facility—Pingyin\nFactory</li></ul>"
                    },
                    "right": {
                        "position": "right",
                        "type": "image",
                        "url": "/assets/images/timeline/timeline desktop_1.webp"
                    }
                }
            },
            {
                "order": 2,
                "items": {
                    "left": {
                        "type": "none"
                    },
                    "right": {
                        "position": "right",
                        "type": "card",
                        "title": "2001",
                        "description": "Expanded production network by leasing Shandong Plastics Pilot Plant in Jinan"
                    }
                }
            },
            {
                "order": 3,
                "items": {
                    "left": {
                        "position": "left",
                        "type": "card",
                        "title": "2003",
                        "description": "Further leased Yangzi Factory in Weifang's Binhai District"
                    },
                    "right": {
                        "type": "none"
                    }
                }
            },
            {
                "order": 4,
                "items": {
                    "left": {
                        "position": "left",
                        "type": "image",
                        "url": "/assets/images/timeline/timeline desktop_2.webp"
                    },
                    "right": {
                        "position": "right",
                        "type": "card",
                        "title": "2005",
                        "description": "Strategic Milestone: First Self-Built Factory Launched in Weifang"
                    }
                }
            }
        ]
    },
    {
        sectionId: "2",
        range: "2009-2011",
        title: "Transformation and exploration period",
        backgroundColor: "#7db628",
        textColor: "#FFFFFF",
        events: [
            {
                order: 1,
                items: {
                    left: {
                        position: "left",
                        type: "card",
                        title: "2009",
                        description: "Overseas expansion begins with own registrations in Argentina and Australia"
                    },
                    right: {
                        position: "right",
                        type: "image",
                        url: "/assets/images/timeline/timeline desktop_3.webp"
                    }
                }
            }
        ]
    },
    {
        sectionId: "3",
        range: "2012-2018",
        title: "Rapid Market Access Platform phase",
        backgroundColor: "#00915c",
        textColor: "#FFFFFF",
        events: [
            {
                order: 1,
                items: {
                    left: {
                        position: "left",
                        type: "image",
                        url: "/assets/images/timeline/timeline desktop_4.webp"
                    },
                    right: {
                        position: "right",
                        type: "card",
                        title: "2012",
                        description: "Investment in Building a Global Rapid Market Access Platform"
                    }
                }
            },
            {
                order: 2,
                items: {
                    left: {
                        position: "left",
                        type: "card",
                        title: "2015",
                        description: `<ul><li>Investment in Qingdao factory</li><li>Strategic Breakthrough: First Overseas
Manufacturing Base Acquired in Argentina</li><li>Local operations launched in Central
America, Malaysia, and Ghana.</li></ul>`
                    },
                    right: {
                        position: "right",
                        type: "image",
                        url: "/assets/images/timeline/timeline desktop_5.webp"
                    }
                }
            },
            {
                order: 3,
                items: {
                    left: {
                        position: "left",
                        type: "image",
                        url: "/assets/images/timeline/timeline desktop_6.webp"
                    },
                    right: {
                        position: "right",
                        type: "card",
                        title: "2016",
                        description: `<ul><li>Acquisition of Ningxia South Plant</li><li>Local operations launched in Bolivia,
Paraguay, Uruguay, and Myanmar</li></ul>`
                    }
                }
            }
        ]
    },

    {
        sectionId: "4",
        range: "2019-2025",
        title: "Becoming a Global Leading Crop Protection Company",
        backgroundColor: "#00746b",
        textColor: "#FFFFFF",
        events: [
            {
                order: 1,
                items: {
                    left: {
                        position: "left",
                        type: "card",
                        title: "2019",
                        description: "Strategic planning for global leadership"
                    },
                    right: {
                        position: "right",
                        type: "image",
                        url: "/assets/images/timeline/timeline desktop_7.webp"
                    }
                }
            },
            {
                order: 2,
                items: {
                    left: {
                        position: "left",
                        type: "image",
                        url: "/assets/images/timeline/timeline desktop_8.webp"
                    },
                    right: {
                        position: "right",
                        type: "card",
                        title: "2020",
                        description: "New headquarters and R&D center inaugurated"
                    }
                }
            },
            {
                order: 3,
                items: {
                    left: {
                        position: "left",
                        type: "card",
                        title: "2021",
                        description: "Listed on Shenzhen Stock Exchange (Stock Code: 301035)"
                    },
                    right: {
                        position: "right",
                        type: "image",
                        url: "/assets/images/timeline/timeline desktop_9.webp"
                    }
                }
            },
            {
                order: 4,
                items: {
                    left: {
                        position: "left",
                        type: "image",
                        url: "/assets/images/timeline/timeline desktop_10.webp"
                    },
                    right: {
                        position: "right",
                        type: "card",
                        title: "2022",
                        description: `<ul><li>Acquisition of Sarabia (Spain), commence full-scale EU investment operations</li><li>Second plant investment in Argentina</li><li>Local operations launched in Thailand, Indonesia, Uzbekistan, Argentina, Brazil, Uganda, Cameroon, Kenya, Zambia</li></ul>`
                    }
                }
            },
            {
                order: 5,
                items: {
                    left: {
                        position: "left",
                        type: "card",
                        title: "2023",
                        description: `<ul><li>Investment in global SAP S/4HANA system</li><li>Local operations launched in Russia, Turkey, Ecuador, Cambodia, Bangladesh</li></ul>`
                    },
                    right: {
                        position: "right",
                        type: "image",
                        url: "/assets/images/timeline/timeline desktop_11.webp"
                    }
                }
            },
            {
                order: 4,
                items: {
                    left: {
                        position: "left",
                        type: "image",
                        url: "/assets/images/timeline/timeline desktop_12.webp"
                    },
                    right: {
                        position: "right",
                        type: "card",
                        title: "2024",
                        description: `<ul><li>Acquisition of U.S. Houston Plant, commence full-scale North America investment operations</li><li>Global launch of Rainbow Bio</li><li>Opening of the Weifang Process Development Center</li></ul>`
                    }
                }
            },
            {
                order: 5,
                items: {
                    left: {
                        position: "left",
                        type: "card",
                        title: "2025",
                        description: "Acquisition of Partner Production Center site in Champaign, IL, USA"
                    },
                    right: {
                        type: "none"
                    }
                }
            }
        ]
    },

    {
        sectionId: "6",
        range: "",
        title: "All about Growing",
        backgroundColor: "#00746b",
        textColor: "#FFFFFF",
        events: []
    }
];

export default timelineData;
